module.exports = __webpack_public_path__ + "img/slide15.4dbafd99.png";